module.exports = __webpack_public_path__ + "static/img/video-pass.dfe14125.png";